import { createSlice } from "@reduxjs/toolkit";

export const apiKeySlice = createSlice({
  name: 'api-token',
  initialState: {
    token: null
  },
  reducers: {
    getApiToken: (state, { payload }) => {
      state.token = payload
    }
  }
})

export const { getApiToken } = apiKeySlice.actions